import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-heading gfu-heading--main _mt-6" }
const _hoisted_3 = { class: "gfu-subheading gfu-subheading--main _mb-3" }
const _hoisted_4 = { class: "gfu-box gfu-box--thick _mt-3" }
const _hoisted_5 = { class: "gfu-heading _mt-3" }
const _hoisted_6 = { class: "gfu-subheading gfu-subheading--wizard _mb-3" }
const _hoisted_7 = { "format-key": "0" }
const _hoisted_8 = {
  key: 0,
  class: "gfu-flex__container--l"
}
const _hoisted_9 = { class: "_tac _pa-3 _flexb50--l gfu-box__left gfu-box__left--separator" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "_tac _pa-3 _flexb50--l gfu-box__separator gfu-box__left" }
const _hoisted_13 = { class: "gfu-box--centered" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  class: "gfu-heading",
  "data-qa": "create-account:PickNameHeader"
}
const _hoisted_16 = { class: "gfu-subheading gfu-subheading--wizard _mb-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_create_creator_account_form = _resolveComponent("create-creator-account-form")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Account.CreateCreatorAccountHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Account.CreateCreatorAccountSubheader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.Resources.Account.CreateCreatorAccountStepOneText) + " ", 1 /* TEXT */),
        ($props.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 0,
              name: "check-circle",
              class: "gfu-heading__icon--accent"
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($props.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_localize, {
              key: 0,
              resource: _ctx.Resources.Account.CreateCreatorAccountStepOneParagraph1
            }, {
              default: _withCtx(() => [
                _createElementVNode("strong", _hoisted_7, _toDisplayString($props.userEmail), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.Resources.Account.CreateCreatorAccountStepOneParagraph2), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      (!$props.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.Resources.Account.CreateCreatorAccountLoginOptionParagraph) + " ", 1 /* TEXT */),
                _createElementVNode("p", null, [
                  _createElementVNode("a", {
                    href: _ctx.loginUrlWithReturn,
                    class: "gfu-btn gfu-btn--accent gfu-btn--wide gfu-btn--soft gfu-btn--compact",
                    "data-qa": "create-account-button:LogIn"
                  }, _toDisplayString(_ctx.Resources.Account.LogInButton), 9 /* TEXT, PROPS */, _hoisted_11)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.Resources.Account.CreateCreatorAccountSingUpOptionParagraph) + " ", 1 /* TEXT */),
                _createElementVNode("p", null, [
                  _createElementVNode("a", {
                    href: _ctx.createAccountUrlWithReturn,
                    class: "gfu-btn gfu-btn--primary gfu-btn--wide gfu-btn--soft gfu-btn--compact",
                    "data-qa": "create-account-button:SignUp"
                  }, _toDisplayString(_ctx.Resources.Account.SignUpButton), 9 /* TEXT, PROPS */, _hoisted_14)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(['_pt-3', $options.disabledClass])
      }, [
        _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.Resources.Account.CreateCreatorAccountStepTwoText), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.Resources.Account.CreateCreatorAccountStepTwoParagraph), 1 /* TEXT */),
        _createElementVNode("div", null, [
          _createVNode(_component_create_creator_account_form, {
            "creator-url": $props.creatorUrl,
            "read-only": !$props.isAuthenticated,
            onContinue: $options.onContinue
          }, null, 8 /* PROPS */, ["creator-url", "read-only", "onContinue"]),
          _createVNode(_component_progress_overlay, {
            sticky: true,
            visible: _ctx.isProcessing
          }, null, 8 /* PROPS */, ["visible"])
        ])
      ], 2 /* CLASS */)
    ])
  ]))
}